import './ListHeader.scss'

import React, { useCallback, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { Button, Icon, SearchBar } from 'hb4e-ui-core-ui'
import { openCreateListForm } from 'hb4e-ui-context'

import { urlListSearch } from '../../../urls'
import { fetchLists, resetListSearchResults } from '../../../actions'

const ListHeader = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const [searchBarValue, setSearchBarValue] = useState(searchParams.get('term') || '')

  const handleSearchBarOnChange = useCallback((event) => setSearchBarValue(event.target.value), [setSearchBarValue])
  const handleSearchBarOnSubmit = useCallback(
    async (event) => {
      event.preventDefault()
      const inputValue = searchBarValue.trim()
      if (inputValue.length !== 1) {
        await dispatch(resetListSearchResults())
        navigate(urlListSearch(inputValue))
      }
    },
    [searchBarValue, dispatch],
  )

  const onCreateListSuccess = useCallback(() => {
    dispatch(fetchLists())
  }, [dispatch])

  const handleOnCreateListClick = useCallback(() => {
    dispatch(openCreateListForm({ onSuccess: onCreateListSuccess }))
  }, [dispatch, onCreateListSuccess])

  return (
    <div className="list-header">
      <section className="list-header__title-section">
        <div className="list-header__container">
          <h1 className="list-header__title">My Lists</h1>
          <p className="list-header__info">
            Use Lists to save items you may want to review later. Lists items can be added to Coursepacks if you would
            like to assign those course materials to students.
          </p>
        </div>
      </section>
      <section className="list-header__actions-section">
        <div className="list-header__actions-container">
          <SearchBar
            className="list-header__search-bar"
            placeholder="Search within My Lists"
            name="myListsSearch"
            id="lists-search"
            value={searchBarValue}
            onChange={handleSearchBarOnChange}
            onSubmit={handleSearchBarOnSubmit}
            ariaLabel="Search My Lists"
            aria-live="polite"
          />
          <Button
            className="list-header__create-list"
            theme="primary solid"
            icon={<Icon.Plus />}
            onClick={handleOnCreateListClick}
          >
            Create New List
          </Button>
        </div>
      </section>
    </div>
  )
}

export default ListHeader
